export default "__VITE_ASSET__c69f9989__"